import React from 'react'
import { Modal, ModalOverlay, ModalContent, ModalBody } from '@chakra-ui/react'
import { Box } from '@chakra-ui/react'
import { Image } from '@chakra-ui/react'
import { CloseIcon } from '@chakra-ui/icons'
import { IconButton } from '@chakra-ui/react'
import { AttachmentType } from '~graphql/generated/graphql'

interface Props {
    isOpen: boolean
    onClose: () => void
    url: string
    type?: AttachmentType
}

export default function ImagePreviewModal({
    isOpen,
    onClose,
    url,
    type = AttachmentType.Image,
}: Props) {
    const isVideo = type === AttachmentType.Video

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            size="3xl"
            closeOnOverlayClick={false}
            isCentered
        >
            <ModalOverlay />
            <ModalContent bg="transparent" shadow="none" w="fit-content">
                <ModalBody
                    display="flex"
                    justifyContent="center"
                    alignItems="flex-start"
                    gridGap={4}
                >
                    <Box w="32px" h="32px" />
                    {isVideo ? (
                        <Box
                            as="video"
                            src={url}
                            h="auto"
                            w="50vw"
                            objectFit="contain"
                            controls
                        />
                    ) : (
                        <Image
                            src={url}
                            alt="Preview"
                            w="auto"
                            h="60vh"
                            objectFit="contain"
                        />
                    )}
                    <IconButton
                        variant="ghost"
                        colorScheme="blackAlpha"
                        size="sm"
                        icon={<CloseIcon color="white" />}
                        onClick={onClose}
                        aria-label="Close"
                    />
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}
